export default __webpack_public_path__ + "static/media/45.135f9a67.jpeg";